import { render, staticRenderFns } from "./OneByOneClassList.vue?vue&type=template&id=5ebc5e7c&scoped=true&"
import script from "./OneByOneClassList.vue?vue&type=script&lang=js&"
export * from "./OneByOneClassList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ebc5e7c",
  null
  
)

export default component.exports